import { authModel } from '@_entities/auth';
import { toastGenerate } from '@_shared/libs';

export function loginToast() {
	toastGenerate({
		message: '딸깍의 더 많은 기능을 이용하려면 로그인이 필요해요!',
		buttonText: '로그인하기',
		onClick: () => {
			window.location.href = '/login';
		},
	});
}

export function toastLoginErrorMessage(
	errorType: authModel.TLoginErrorCode | string,
	errorMessage: string | null,
) {
	if (errorType === 'EL01') {
		toastGenerate({
			message: `다른 소셜 이메일로 가입되어 있습니다. ${errorMessage}로 로그인 해주세요`,
			buttonText: '문의하기',
			onClick: () => {
				window.location.href = 'http://pf.kakao.com/_xgxfxoxcG/chat';
			},
		});
	} else if (errorType.includes('EL')) {
		toastGenerate({
			message: `로그인에 오류가 있습니다.(코드:${errorType})
			고객센터로 문의해주십시오.`,
			buttonText: '문의하기',
			onClick: () => {
				window.location.href = 'http://pf.kakao.com/_xgxfxoxcG/chat';
			},
		});
	} else {
		toastGenerate({
			message: '로그인 실패했습니다. 다시 로그인 시도해 주세요',
			buttonText: '문의하기',
			onClick: () => {
				window.location.href = 'http://pf.kakao.com/_xgxfxoxcG/chat';
			},
		});
	}
}
